<template>
    <inertia-link
        v-if="href && !(disabled || loading) && isInertia && !shouldTargetBlank"
        v-tooltip="label ? label : null"
        :href="href"
    >
        <slot/>
    </inertia-link>

    <a
        v-else-if="href && !(disabled || loading)"
        v-tooltip="label ? label : null"
        :href="href"
        :target="shouldTargetBlank ? '_blank' : '_self'"
    >
        <slot/>
    </a>

    <div v-else v-tooltip="label ? label : null">
        <slot/>
    </div>
</template>

<script>
export default {
    props: {
        href: {
            type: String,
            default: null,
        },
        label: {
            type: String,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        isInertia: {
            type: Boolean,
            default: true,
        },
        shouldTargetBlank: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
